"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FleshlightLaunch = void 0;
const Messages = __importStar(require("../../core/Messages"));
const Exceptions_1 = require("../../core/Exceptions");
const ButtplugDeviceProtocol_1 = require("../ButtplugDeviceProtocol");
const Endpoints_1 = require("../Endpoints");
const ButtplugDeviceWriteOptions_1 = require("../ButtplugDeviceWriteOptions");
class FleshlightLaunch extends ButtplugDeviceProtocol_1.ButtplugDeviceProtocol {
    constructor(aDeviceImpl) {
        super("Fleshlight Launch", aDeviceImpl);
        this._lastPosition = 0;
        this.Initialize = () => __awaiter(this, void 0, void 0, function* () {
            this._logger.Debug(`Calling Fleshlight Launch initialize on ${this._device.Name}`);
            yield this._device.WriteValue(Buffer.from([0x00]), new ButtplugDeviceWriteOptions_1.ButtplugDeviceWriteOptions({ Endpoint: Endpoints_1.Endpoints.Firmware,
                WriteWithResponse: true }));
        });
        this.HandleStopDeviceCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            return yield this.HandleFleshlightLaunchFW12Cmd(new Messages.FleshlightLaunchFW12Cmd(0, 0, aMsg.DeviceIndex, aMsg.Id));
        });
        this.HandleFleshlightLaunchFW12Cmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            this._lastPosition = aMsg.Position;
            yield this._device.WriteValue(Buffer.from([aMsg.Position, aMsg.Speed]));
            return new Messages.Ok(aMsg.Id);
        });
        this.HandleLinearCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (aMsg.Vectors.length !== 1) {
                throw new Exceptions_1.ButtplugDeviceException("LinearCmd requires 1 vector for this device.", aMsg.Id);
            }
            // Move between 5/95, otherwise we'll allow the device to smack into hard
            // stops because of braindead firmware.
            const range = 90;
            const vector = aMsg.Vectors[0];
            const currentPosition = vector.Position * 100;
            const positionDelta = Math.abs(currentPosition - this._lastPosition);
            let speed = Math.floor(25000 * Math.pow(((vector.Duration * 90) / positionDelta), -1.05));
            // Clamp speed on 0 <= x <= 95 so we don't break the launch.
            speed = Math.min(Math.max(speed, 0), 95);
            const positionGoal = Math.floor(((currentPosition / 99) * range) + ((99 - range) / 2));
            // We'll set this._lastPosition in FleshlightLaunchFW12Cmd, since
            // everything kinda funnels to that.
            return yield this.HandleFleshlightLaunchFW12Cmd(new Messages.FleshlightLaunchFW12Cmd(speed, positionGoal, aMsg.DeviceIndex, aMsg.Id));
        });
        this.MsgFuncs.set(Messages.StopDeviceCmd, this.HandleStopDeviceCmd);
        this.MsgFuncs.set(Messages.FleshlightLaunchFW12Cmd, this.HandleFleshlightLaunchFW12Cmd);
        this.MsgFuncs.set(Messages.LinearCmd, this.HandleLinearCmd);
    }
    get MessageSpecifications() {
        return {
            FleshlightLaunchFW12Cmd: {},
            StopDeviceCmd: {},
            LinearCmd: { FeatureCount: 1 },
        };
    }
}
exports.FleshlightLaunch = FleshlightLaunch;
//# sourceMappingURL=FleshlightLaunch.js.map